import React from 'react';
import { TrophySpin } from 'react-loading-indicators';

const Loader = () => {
  return (
    <div style={styles.loaderContainer}>
      <TrophySpin color="#00d7f9" size="large" text="Apexcel" textColor="#000000" />
    </div>
  );
};

const styles = {
  loaderContainer: {
    height: '100vh',
    width: '100%',
    background: 'linear-gradient(to right,rgb(255, 255, 255),rgba(255, 187, 0, 0.67))', // skyblue to golden
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default Loader;
